import { Form, Formik } from 'formik'
import React from 'react'
import * as Yup from 'yup'
import {
  COLORS,
  FieldError,
  Label,
  handleInputBlur,
  handleInputFocus,
  inputStyle,
} from '../styleHelpers'
import type { NameStepValues } from '../types'

export const ADD_LOCATION_NAME_FORM_ID = 'addLocationNameForm'

const schema = Yup.object({
  name: Yup.string().trim().required('Please enter a location name'),
})

interface Props {
  initialValues: NameStepValues
  onSubmit: (values: NameStepValues) => void
}

export const NameStep: React.FC<Props> = ({ initialValues, onSubmit }) => (
  <Formik
    initialValues={initialValues}
    enableReinitialize
    validationSchema={schema}
    onSubmit={(values) => onSubmit({ name: values.name.trim() })}
  >
    {({ values, errors, touched, handleChange, handleBlur }) => {
      const hasError = !!(touched.name && errors.name)
      return (
        <Form id={ADD_LOCATION_NAME_FORM_ID}>
          <p
            style={{
              margin: '0 0 18px',
              fontSize: 13,
              color: COLORS.textMuted,
              lineHeight: 1.5,
              fontFamily: 'inherit',
            }}
          >
            Give this location a friendly name. You can use the store name,
            neighbourhood, or anything else that helps you identify it.
          </p>

          <Label htmlFor="add-location-name" required>
            Location name
          </Label>
          <input
            id="add-location-name"
            name="name"
            value={values.name}
            placeholder="e.g. Downtown Vancouver"
            onChange={handleChange}
            onBlur={(e) => {
              handleBlur(e)
              handleInputBlur(hasError)(e)
            }}
            onFocus={handleInputFocus}
            style={inputStyle(hasError)}
          />
          <FieldError msg={hasError ? errors.name : undefined} />
        </Form>
      )
    }}
  </Formik>
)
